import { FilterConfig, FilterGroup, FilterName, FiltersList, FilterWithOptions } from './types';
import { RegisteredAssetListQueryParams } from '@casops/store/apis/registeredAssetsApi';
import { FiltersState } from '@casops/store/slices/filtersSlice';
import { ASSET_LIST_FILTERS, FILTERS_CONFIG, GEOFENCE_FILTERS } from './config';

export const getFiltersList = (filterGroup: FilterGroup): FiltersList => {
  switch (filterGroup) {
    case FilterGroup.AssetsList:
      return ASSET_LIST_FILTERS;
    case FilterGroup.Geofences:
      return GEOFENCE_FILTERS;
    default:
      return [];
  }
};

export type AllowedQueryParams = RegisteredAssetListQueryParams;

export const getFilterName = (filter: FilterName | FilterWithOptions): FilterName => {
  return typeof filter === 'string' ? filter : filter.name;
};

export const getFilterNamesFromFiltersList = (filtersList: FiltersList): FilterName[] => {
  return filtersList.map(
    (filter: FilterName | FilterWithOptions): FilterName => getFilterName(filter),
  );
};

export const getRelevantFilters = <T extends AllowedQueryParams>(
  savedFilters: FiltersState,
  filterNames: FilterName[],
): T => {
  // @ts-expect-error FIXME: This correct, type-safe code needs correct types.
  const relevantFilters: T = {};

  filterNames.forEach((name: FilterName) => {
    // @ts-expect-error FIXME: This correct, type-safe code needs correct types.
    relevantFilters[name] = savedFilters[name];
  });

  return relevantFilters;
};

export const getFilterConfig = (
  filter: FilterName | FilterWithOptions,
): FilterConfig | undefined => {
  return FILTERS_CONFIG.find(({ name }) => name === getFilterName(filter));
};
